<div class="home-container">
  <!-- Animazione di sfondo -->
  <div class="background-animation">
    <ng-lottie [options]="lottieConfig_bg" (animationCreated)="animationCreated($event)"></ng-lottie>
  </div>

  <!-- Box di login centrato -->
  <div class="login-box">
    <div class="logo-container">
      <img src="assets/loghi/logo_no_scritta.png" alt="PMO2 Logo" height="130">
    </div>
    <div class="welcome-text">
      Benvenuto in PMO2!
    </div>
    <p class="description-text">
      Il portale per la gestione integrata dei PIANI di MANUTENZIONE ORDINARIA dell'Unione Montana Valle di Susa.
    </p>

    <div class="login-button-container">
      <button type="button" pButton label="ACCEDI" class="login-button" (click)="loginWithRedirect()"></button>
    </div>
  </div>

  <!-- Footer -->
 <!--  <div class="footer-container">
    <div class="powered-by-text">Powered by</div>
    <div class="powered-by-logo">
      <img src="assets/loghi/logo_latitude.png" alt="Latitude Logo" height="40" (click)="goToVertical()">
    </div>
  </div> -->
</div>
